import { Controller } from "@hotwired/stimulus"

// Assistant IA de rédaction de procédure : affiche le bloc de questions du type
// choisi, suit la progression (réponses renseignées), et gère l'état du bouton
// pendant la génération (Turbo). Les blocs masqués sont DÉSACTIVÉS pour ne pas
// être soumis (des clés answers[...] sont partagées entre types de procédure).
export default class extends Controller {
  static targets = ["kindSelect", "questionBlock", "generateButton", "buttonLabel", "counter"]

  // Textes UI via I18n (data-procedure-ai-draft-*-value). Defaults FR.
  static values = {
    generating: { type: String, default: "Génération en cours…" },
    generate: { type: String, default: "Générer un brouillon" },
    answeredLabel: { type: String, default: "renseignées" }
  }

  connect() {
    this.showQuestionsForSelectedKind()
  }

  kindChanged() {
    this.showQuestionsForSelectedKind()
  }

  get selectedKind() {
    return this.hasKindSelectTarget ? this.kindSelectTarget.value : ""
  }

  showQuestionsForSelectedKind() {
    this.activeFields = []

    this.questionBlockTargets.forEach((block) => {
      const isActive = block.dataset.kind === this.selectedKind
      block.classList.toggle("hidden", !isActive)
      block.querySelectorAll("textarea, input, select").forEach((field) => {
        field.disabled = !isActive
      })
      if (isActive) this.activeFields = Array.from(block.querySelectorAll("textarea"))
    })

    if (this.hasGenerateButtonTarget) {
      this.generateButtonTarget.disabled = this.selectedKind === ""
    }
    this.updateProgress()
  }

  // Compte les réponses renseignées du bloc actif. Les champs sont mémoïsés au
  // changement de type, donc pas de re-scan du DOM à chaque frappe.
  updateProgress() {
    if (!this.hasCounterTarget) return

    const fields = this.activeFields || []
    if (fields.length === 0) {
      this.counterTarget.textContent = ""
      return
    }

    const answered = fields.filter((field) => field.value.trim() !== "").length
    this.counterTarget.textContent = `${answered} / ${fields.length} ${this.answeredLabelValue}`
  }

  submitStart() {
    if (this.hasGenerateButtonTarget) this.generateButtonTarget.disabled = true
    if (this.hasButtonLabelTarget) this.buttonLabelTarget.textContent = this.generatingValue
  }

  submitEnd() {
    if (this.hasGenerateButtonTarget) this.generateButtonTarget.disabled = false
    if (this.hasButtonLabelTarget) this.buttonLabelTarget.textContent = this.generateValue
  }
}
